// extracted by mini-css-extract-plugin
module.exports = {"microWrapper":"styles_microWrapper__Qm2ag"};